export const STAFF_PROFILE_SELECT_FIELDS = [
  'id',
  'email',
  'full_name',
  'role',
  'created_at',
  'avatar_url',
  'avatar_path',
  'avatar_media_id',
  'title',
  'department',
  'voc_owner_key',
].join(', ');
